module.exports = __webpack_public_path__ + "img/3.cd236e97.png";